import React from 'react';
import { P } from 'mf-react-ui/Typography';
import sanitizeHtml from 'sanitize-html';

type Props = {
  html: string;
  options?: sanitizeHtml.IOptions;
  className?: string;
};

const SanitazeMessage: React.FC<Props> = (props) => {
  const { html, options, className } = props;
  const defaultOptions = {
    allowedTags: ['b', 'i', 'em', 'br', 'span', 'a'],
    allowedAttributes: {
      a: ['href'],
    },
    urlAttributes: {
      protocols: ['tel'],
    },
    allowedSchemes: ['tel'],
  };

  const sanitize = (dirty: string, newOptions: sanitizeHtml.IOptions | undefined) => ({
    __html: sanitizeHtml(dirty, { ...defaultOptions, ...newOptions }),
  });
  return (
    <P
      className={`${className || ''}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={sanitize(html, options)}
    />
  );
};

export default SanitazeMessage;
